import { watch } from 'vue';
import { usePlausiblePrivacy } from '~/composables/usePlausiblePrivacy';
import { createPlausibleTracker } from '~/utils/plausible-tracker';
export default defineNuxtPlugin((nuxtApp) => {
  const privacy = usePlausiblePrivacy();
  const config = useRuntimeConfig().public;
  const tracker = createPlausibleTracker(window, {
    endpoint: config.plausibleApiUrl,
    domain: config.plausibleDomain
  });
  window.__idmanifyPlausible = tracker;
  nuxtApp.hook('app:mounted', () => {
    privacy.sync();
    watch(
      privacy.optedOut,
      (disabled) => {
        if (disabled) tracker.revoke();
        else tracker.page();
      },
      { immediate: true, flush: 'sync' }
    );
    const refresh = () => {
      privacy.sync();
      if (privacy.optedOut.value) tracker.revoke();
    };
    try {
      const channel = new BroadcastChannel('idmanify:plausible-preference');
      channel.onmessage = (event) => {
        if (typeof event.data !== 'boolean') return;
        window.__idmanifyPlausibleOptOut = event.data;
        refresh();
      };
      nuxtApp.vueApp.onUnmount(() => channel.close());
    } catch {
      /* BroadcastChannel is optional; cookie checks remain authoritative. */
    }
    window.addEventListener('focus', refresh);
    window.addEventListener('idmanify:plausible-preference', refresh);
    nuxtApp.$router.afterEach(() => {
      refresh();
      tracker.page();
    });
  });
});
